/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import React from 'react';
import { motion } from 'framer-motion';
import cx from 'classnames';

const top = {
  closed: {
    rotate: 0,
    translateY: 0,
    transition: {
      duration: 0.2,
      ease: 'easeOut',
    },
  },
  opened: {
    rotate: 45,
    translateY: 3,
    transition: {
      delay: 0.2,
      duration: 0.2,
      ease: 'easeOut',
    },
  },
};

const center = {
  closed: {
    opacity: 1,
    // x: "30%",
    transition: {
      delay: 0.2,
      duration: 0.2,
      ease: 'easeOut',
    },
  },
  opened: {
    opacity: 0,
    transition: {
      duration: 0.2,
      ease: 'easeOut',
    },
  },
};

const bottom = {
  closed: {
    rotate: 0,
    translateY: 0,
    transition: {
      duration: 0.2,
      ease: 'easeOut',
    },
  },
  opened: {
    rotate: -45,
    translateY: -3,
    transition: {
      delay: 0.2,
      duration: 0.2,
      ease: 'easeOut',
    },
  },
};

const BurgerMenu = ({
  navOpen,
  toggleNav,
  reverseHeader,
  width = 26,
  height = 18.5,
  isPinned,
}) => {
  // const breakpoints = useBreakpoint();
  const variant = navOpen ? 'opened' : 'closed';
  const unitHeight = 8;
  const unitWidth = (unitHeight * width) / height;

  return (
    <button
      onClick={() => {
        toggleNav();
      }}
      className={cx(
        'flex items-center justify-center cursor-pointer h-12 w-12 rounded-full relative',
        {
          'bg-white/10': !navOpen,
          'bg-blue/5': navOpen || reverseHeader || isPinned,
        },
      )}
      style={{
        WebkitBackdropFilter: 'blur(7px)',
        backdropFilter: 'blur(7px)',
      }}>
      <motion.svg
        viewBox={`0 0 ${unitWidth} ${unitHeight}`}
        overflow='visible'
        preserveAspectRatio='none'
        width={width}
        height={height}
        strokeWidth='2'
        className='absolute top-[17px] left-1/2 -translate-x-1/2 '>
        <motion.line
          stroke={navOpen || reverseHeader || isPinned ? '#009A4D' : '#fff'}
          x1='0'
          x2={unitWidth}
          y1='0'
          y2='0'
          variants={top}
          animate={variant}
          initial='closed'
          vectorEffect='non-scaling-stroke'
          strokeLinecap='round'
          className='transition-all ease-in-out duration-300 '
        />
        <motion.line
          stroke={navOpen || reverseHeader || isPinned ? '#009A4D' : '#fff'}
          x1='0'
          x2={unitWidth}
          y1='3'
          y2='3'
          variants={center}
          animate={variant}
          initial='closed'
          vectorEffect='non-scaling-stroke'
          strokeLinecap='round'
          className='transition-all ease-in-out duration-300'
        />
        <motion.line
          stroke={navOpen || reverseHeader || isPinned ? '#009A4D' : '#fff'}
          x1='0'
          x2={unitWidth}
          y1='6'
          y2='6'
          variants={bottom}
          animate={variant}
          initial='closed'
          vectorEffect='non-scaling-stroke'
          strokeLinecap='round'
          className='transition-all ease-in-out duration-300'
        />
      </motion.svg>
    </button>
  );
};

export default BurgerMenu;
